import React, { useState, useEffect } from 'react'
import { TextField, MenuItem, Autocomplete, createFilterOptions } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectEmployees } from '../stores/employeeSlice';
import ApiClient from '../ApiClient';

import ReactDOMServer from 'react-dom/server';
import html2pdf from 'html2pdf.js/dist/html2pdf.min';
import img from '../../src/images/DAFullLogo.png';
import onlyLogo from '../../src/images/OnlyLogo.png';
import footerimg from '../../src/images/NameLogo.png'
import OfferLetter from '../letters/OfferLetter';
import { notify } from '../utils/ToastUtils';
import InternshipCompletionLetter from '../letters/InternshipCompletionLetter';
import InternOfferLetter from '../letters/InternOfferLetter';
import AddressProofLetter from '../letters/AddressProofLetter';
import ExitLetter from '../letters/ExitLetter';
import ProvisionalOfferLetter from '../letters/ProvisionalOfferLetter';
import LoaderIcon from '../components/LoaderIcon';
import { FileSignature, CircleAlert } from 'lucide-react';
import TailwindModal, { TailwindModalHeader, TailwindModalBody, TailwindModalFooter } from '../components/TailwindModal';
import { LETTER_TYPES, DEGREES, DESIGNATIONS } from '../utils/constants';
const filter = createFilterOptions();
const printHandler = (content, pdfName, returnType = 'save') => {
    const printElement = ReactDOMServer.renderToString(content);
    // const printElement = pdfJSX();
    const opt = {
        margin: [30, 10, 30, 10],
        filename: `${pdfName}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        html2canvas: { dpi: 75, scale: 2, letterRendering: true },
        // pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
        pagebreak: { before: '.pagebreakneed', avoid: ['img', 'table' ,'p','tr','th'] }
    };
    const pageBreakElements = document.getElementsByClassName('page-break');
    for (let i = 0; i < pageBreakElements.length; i++) {
        pageBreakElements[i].style.pageBreakBefore = 'always';
    }
    
    const worker = html2pdf().from(printElement).set(opt).toPdf();
    
    return worker.get('pdf').then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();
        const pageWidth = pdf.internal.pageSize.getWidth();

            // Line 1 parts
            const line1Parts = [
            { text: 'D', color: '#961a1d' },
            { text: '-ACES', color: '#FCCC0B' },
            { text: ' INDIA PRIVATE LIMITED ', color: 150 },
            { text: ' |', color: '#961a1d' },
            { text: ' Gateway Office Parks - Block B6 - First Floor ', color: 150 },
            { text: '|', color: '#961a1d' },
            { text: ' 16 GST Road ', color: 150 },
            { text: '|', color: '#961a1d' },
            { text: ' Perungalathur', color: 150 }
            ];

            // Line 2 parts
            const line2Parts = [
            { text: ' Chennai 600063 ', color: 150 },
            { text: '|', color: '#961a1d' },
            { text: ' INDIA', color: 150 }
            ];

            // Helper to draw colored and centered text line
            const drawColoredLine = (pdf, parts, y) => {
            const totalWidth = parts.reduce((sum, part) => sum + pdf.getTextWidth(part.text), 0);
            let x = (pageWidth - totalWidth) / 2;

            parts.forEach(part => {
            pdf.setTextColor(part.color);
            pdf.text(part.text, x, y);
            x += pdf.getTextWidth(part.text);
            });
            };

        for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(8);
            pdf.setFont('helvetica');
                        
            const y1 = pdf.internal.pageSize.getHeight() - 11;
            const y2 = pdf.internal.pageSize.getHeight() - 6;
                        
            // Draw colored, centered footer lines
            drawColoredLine(pdf, line1Parts, y1);
            drawColoredLine(pdf, line2Parts, y2);
                        
            // Add images (centered)
            const topLogo = img;
            const topLogoWidth =  40;
            const topLogoHeight = 18;
            
            pdf.addImage(topLogo, 'png', (pageWidth - topLogoWidth) / 2, 5, topLogoWidth, topLogoHeight);
            pdf.addImage(footerimg, 'png', (pageWidth - 32) / 2, pdf.internal.pageSize.getHeight() - 20, 30, 5);
              
        }
    }).then(() => {
        if (returnType === 'save') {
            return worker.save();
        } else {
            return worker.output('bloburl');
        }
    });
}

const initialoffer = {
    Name: "",
    valid: "",
    designation: "",
    ctc: "",
    address1: "",
    address2: "",
    address3: "",
    mail: "",
    number: "",
    basic: "",
    hra: "",
    conveyance: "",
    doj: "",
    medical: "",
    sp: "",
    customComponents: [],
    pf: "",
    graduity: "",
    bonus: "",
    total: ""
}

const initialIntern = {
    Name: "",
    rollNo: "",
    degree: "",
    depart: "",
    collegename: "",
    startdate: "",
    enddate: "",
}

const initialInternOff = {
    Name: "",
    valid:"",
    collegename: "",
    startdate: "",
    enddate: "",
}

const initialaddress = {
    Name: "",
    id:"",
    designation: "",
    doj: "",
    address1: "",
    address2: "",
    address3: "",
}

const initialExit = {
    Name: "",
    id:"",
    designation: "",
    doj: "",
    exit:"",
    last:""
}

const initialProvisional = {
    Gender:"",
    Name: "",
    roll: "",
    degree: "",
    depart: "",
    collegeName: "",
    CTC:'',
    mail: "",
    doj: ""
}
    
function LetterGeneration({ letterData, clearLetterData }) {
    const employees = useSelector(selectEmployees);
    const [candidates, setCandidates] = useState([]);

    useEffect(() => {
        ApiClient.get(`${process.env.REACT_APP_BASE_URL}/admin/getIntern`)
            .then(res => setCandidates(res.data || []))
            .catch(err => console.error(err));
    }, []);

    const [isDisabled, setIsDisabled] = useState(false)
    const [submitAttempted, setSubmitAttempted] = useState(false)
    const [letterType, setLetterType] = useState('')
    const [previewModal, setPreviewModal] = useState(false)
    const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null)
    const [isPreviewLoading, setIsPreviewLoading] = useState(false)

    useEffect(() => {
        if (letterData) {
            setLetterType(letterData.type);
            if (letterData.type === 'offerLetter') {
                setOffer(prev => ({ ...prev, ...letterData.data }));
            } else if (letterData.type === 'internOfferLetter') {
                setInternOff(prev => ({ ...prev, ...letterData.data }));
            } else if (letterData.type === 'provisionalOfferLetter') {
                setProvisional(prev => ({ ...prev, ...letterData.data }));
            }
            if (clearLetterData) clearLetterData();
        }
    }, [letterData]);
    const letterTypeSet = (e) => {
        e.preventDefault()
        setLetterType(e.target.value)
        setSubmitAttempted(false);
    }
    const [offer, setOffer] = useState(initialoffer)
    function handleChangeOffer(evt) {
        const value = evt.target.value;
        setOffer({
            ...offer,
            [evt.target.name]: value
        });
    }

    const addCustomComponent = () => {
        setOffer({
            ...offer,
            customComponents: [...(offer.customComponents || []), { name: '', value: '' }]
        });
    };

    const handleCustomComponentChange = (index, field, value) => {
        const newComponents = [...(offer.customComponents || [])];
        newComponents[index][field] = value;
        setOffer({ ...offer, customComponents: newComponents });
    };

    const removeCustomComponent = (index) => {
        const newComponents = [...(offer.customComponents || [])];
        newComponents.splice(index, 1);
        setOffer({ ...offer, customComponents: newComponents });
    };

    const [Intern, setIntern] = useState(initialIntern)
    function handleChangeIntern(evt) {
        const value = evt.target.value;
        setIntern({
            ...Intern,
            [evt.target.name]: value
        });
    }

    const [InternOff, setInternOff] = useState(initialInternOff)
    function handleChangeInternOff(evt) {
        const value = evt.target.value;
        setInternOff({
            ...InternOff,
            [evt.target.name]: value
        });
    }

    const [address, setAddress] = useState(initialaddress)
    function handleChangeAddress(evt) {
        const value = evt.target.value;
        const name = evt.target.name;
        let updates = { [name]: value };
        
        if (name === 'Name') {
            const emp = employees?.find(e => e.EMP_NAME === value);
            if (emp) {
                if (emp.EMP_ID) updates.id = emp.EMP_ID;
                if (emp.EMP_DATE_OF_JOIN) updates.doj = emp.EMP_DATE_OF_JOIN.substring(0, 10);
            }
        }
        
        setAddress({ ...address, ...updates });
    }

    const [exit, setExit] = useState(initialExit)
    function handleChangeExit(evt) {
        const value = evt.target.value;
        const name = evt.target.name;
        let updates = { [name]: value };
        
        if (name === 'Name') {
            const emp = employees?.find(e => e.EMP_NAME === value);
            if (emp) {
                if (emp.EMP_ID) updates.id = emp.EMP_ID;
                if (emp.EMP_DATE_OF_JOIN) updates.doj = emp.EMP_DATE_OF_JOIN.substring(0, 10);
            }
        }
        
        setExit({ ...exit, ...updates });
    }

    const [provisional, setProvisional] = useState(initialProvisional)
    function handleChangeProvisional(evt) {
        const value = evt.target.value;
        setProvisional({
            ...provisional,
            [evt.target.name]: value
        });
    }

    
    function isFormValid() {
        if (letterType === 'offerLetter') return !!(offer.Name && offer.valid && offer.designation && offer.ctc && offer.address1 && offer.mail && offer.number && offer.basic && offer.hra && offer.conveyance && offer.medical && offer.sp && offer.pf && offer.graduity && offer.bonus && offer.total);
        if (letterType === 'internLetter') return !!(Intern.Name && Intern.rollNo && Intern.degree && Intern.depart && Intern.collegename && Intern.startdate && Intern.enddate);
        if (letterType === 'internOfferLetter') return !!(InternOff.Name && InternOff.collegename && InternOff.startdate && InternOff.enddate);
        if (letterType === 'addressProofLetter') return !!(address.Name && address.id && address.designation && address.doj && address.address1);
        if (letterType === 'exitLetter') {
            if (!(exit.Name && exit.id && exit.designation && exit.doj && exit.exit && exit.last)) return false;
            if (new Date(exit.doj) >= new Date(exit.exit) || new Date(exit.doj) >= new Date(exit.last)) {
                return false;
            }
            return true;
        }
        if (letterType === 'provisionalOfferLetter') return !!(provisional.Name && provisional.Gender && provisional.mail && provisional.doj && provisional.roll && provisional.degree && provisional.depart && provisional.collegeName && provisional.CTC);
        return true;
    }

    async function generateOffer() {
        if (offer.Name && offer.valid && offer.designation && offer.ctc && offer.address1 && offer.mail && offer.number && offer.basic && offer.hra && offer.conveyance && offer.medical && offer.sp && offer.pf && offer.graduity && offer.bonus && offer.total) {
            await printHandler(<OfferLetter data={offer} />,"Offer-Letter")
            cleanup();
        } else { 
             
        }
        setIsDisabled(false)
    }


    async function generateIntern() {
        if (Intern.Name && Intern.rollNo && Intern.degree && Intern.depart && Intern.collegename && Intern.startdate && Intern.enddate) {
            await printHandler(<InternshipCompletionLetter data={Intern} />,"Internship-Comletion-Letter")
            cleanup();
        } else {  }

        setIsDisabled(false)
        
    }

    async function generateInternOff() {
        if (InternOff.Name  && InternOff.collegename && InternOff.startdate && InternOff.enddate) {
            await printHandler(<InternOfferLetter data={InternOff} />,"Intern-Offer-Letter")
            cleanup();
        } else {  }

        setIsDisabled(false)
        
    }

    async function generateAddress() {
        if (address.Name && address.id && address.designation && address.doj && address.address1) {
            await printHandler(<AddressProofLetter data={address} />,"Address-proof-Letter")
            cleanup();
        } else {  }

        setIsDisabled(false)
        
    }

    async function generateExit() {
        if (exit.Name && exit.id && exit.designation && exit.doj && exit.exit && exit.last) {
            await printHandler(<ExitLetter data={exit} />,"Exit-Letter")
            cleanup();
        } else {  }
     
        setIsDisabled(false)
    }

    async function generateProvisionalOffer() {
        
        if (provisional.Name && provisional.Gender && provisional.mail && provisional.doj && provisional.roll && provisional.degree && provisional.depart && provisional.collegeName && provisional.CTC) {
            await printHandler(<ProvisionalOfferLetter data={provisional} />,"provisionalOfferLetter")
            cleanup();
        } else {  }
     
        setIsDisabled(false)
    }
    async function handleGenerate() {
        setSubmitAttempted(true);
        if (!isFormValid()) return;
        setIsDisabled(true);
        
        // Yield to browser's render loop so React can paint the loading spinner before html2pdf locks the main thread
        await new Promise(resolve => setTimeout(resolve, 50));
        
        if (letterType == "offerLetter") {
            await generateOffer();
        }else if(letterType == "internLetter"){
            await generateIntern();
        }else if(letterType == "internOfferLetter"){
            await generateInternOff();
        }else if(letterType == "addressProofLetter"){
            await generateAddress();
        }else if(letterType == "exitLetter"){
            await generateExit();
        }else if(letterType == "provisionalOfferLetter"){
            await generateProvisionalOffer();
        }
    }

    function cleanup(){
        // setSubmitAttempted(false);
        // setOffer(initialoffer);
        // setIntern(initialIntern);
        // setInternOff(initialInternOff);
        // setAddress(initialaddress);
        // setExit(initialExit);
    }
    const muiFieldSx = {
    '& .MuiOutlinedInput-root': {
        height: '38px',
        borderRadius: '8px',
        fontSize: '14px',
        backgroundColor: '#ffffff',
    },
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#e2e8f0',
    },
    '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: '#ef4444 !important',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#cbd5e1',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#3b82f6',
    },
    '& .MuiSelect-select': {
        padding: '8.5px 14px',
    },
    '& input': {
        padding: '8.5px 14px',
    }
};
    const labelClass = "block text-[13px] font-semibold text-slate-700 mb-1.5";

    const renderNameAutocomplete = (label, nameField, value, onChangeHandler, hasError, options) => {
        return (
            <div>
                <label className={labelClass}>{label}<span className="text-red-500">*</span></label>
                <Autocomplete
                    freeSolo
                    options={options}
                    value={value || ''}
                    onChange={(event, newValue) => {
                        onChangeHandler({ target: { name: nameField, value: newValue || '' } });
                    }}
                    onInputChange={(event, newInputValue) => {
                        onChangeHandler({ target: { name: nameField, value: newInputValue || '' } });
                    }}
                    filterOptions={(opts, params) => {
                        const filtered = filter(opts, params);
                        const { inputValue } = params;
                        const isExisting = opts.some((opt) => inputValue === opt);
                        if (inputValue !== '' && !isExisting) {
                            filtered.push(inputValue);
                        }
                        return filtered;
                    }}
                    renderOption={(props, option) => {
                        const isNew = !options.includes(option);
                        return (
                            <li {...props} style={{ fontSize: '13px' }}>
                                {isNew ? `Add "${option}"` : option}
                            </li>
                        );
                    }}
                    renderInput={(params) => (
                        <TextField {...params} error={hasError} placeholder={`Enter ${label.replace('*', '').trim()}`} sx={muiFieldSx} fullWidth />
                    )}
                />
            </div>
        );
    };

    return (
        <div className="flex flex-col w-full gap-4">
            <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
                <div className="p-4 md:px-5 md:py-4 border-b border-slate-100 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full bg-brand-50 flex items-center justify-center text-brand-600 shrink-0">
                            <FileSignature size={20} />
                        </div>
                        <div>
                            <h2 className="text-[16px] font-bold text-slate-800 m-0 leading-tight">Letter Generation</h2>
                            <p className="text-xs text-slate-500 font-medium mt-0.5 block m-0">Generate various official letters for employees and interns</p>
                        </div>
                    </div>
                    {letterType && (
                        <div className="flex gap-2">
                            <button
                                onClick={async () => {
                                    setSubmitAttempted(true);
                                    if (isFormValid()) {
                                        setPreviewModal(true);
                                        setIsPreviewLoading(true);
                                        setPdfPreviewUrl(null);
                                        
                                        // Yield for modal animation
                                        await new Promise(resolve => setTimeout(resolve, 50));
                                        
                                        let content = null;
                                        let name = "";
                                        if (letterType === 'offerLetter') { content = <OfferLetter data={offer} />; name = "Offer-Letter"; }
                                        else if (letterType === 'internLetter') { content = <InternshipCompletionLetter data={Intern} />; name = "Internship-Completion-Letter"; }
                                        else if (letterType === 'internOfferLetter') { content = <InternOfferLetter data={InternOff} />; name = "Intern-Offer-Letter"; }
                                        else if (letterType === 'addressProofLetter') { content = <AddressProofLetter data={address} />; name = "Address-Proof-Letter"; }
                                        else if (letterType === 'exitLetter') { content = <ExitLetter data={exit} />; name = "Exit-Letter"; }
                                        else if (letterType === 'provisionalOfferLetter') { content = <ProvisionalOfferLetter data={provisional} />; name = "Provisional-Offer-Letter"; }
                                        
                                        if (content) {
                                            const url = await printHandler(content, name, 'bloburl');
                                            setPdfPreviewUrl(url);
                                        }
                                        setIsPreviewLoading(false);
                                    }
                                }}
                                className="px-5 py-2 rounded-lg font-bold text-[13px] tracking-wide transition-all shadow-sm flex items-center justify-center gap-2 bg-brand-600 text-white hover:bg-brand-700 hover:shadow-md hover:shadow-brand-600/20 active:scale-95"
                            >
                                Preview & Generate Letter
                            </button>
                        </div>
                    )}
                </div>

                <div className="p-6 pt-3">
                    <form onSubmit={(e) => e.preventDefault()}>
                        <div className="space-y-6">

                            {submitAttempted && !isFormValid() && (
                                <div className="flex items-center gap-2 rounded-md border border-red-200 bg-red-50 px-3 py-1.5 text-xs font-medium text-red-600">
                                    <CircleAlert size={16} />
                                    <span>Please complete all required fields.</span>
                                </div>
                            )}

                            <div className="max-w-md">
                                <label className={labelClass}>Select Letter Type <span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !letterType} select
                                    name='timesheetFilter' 
                                    sx={muiFieldSx}
                                    SelectProps={{ displayEmpty: true, MenuProps: { sx: { '& .MuiMenuItem-root': { fontSize: '14px' } } } }}
                                    fullWidth
                                    value={letterType}
                                    onChange={letterTypeSet} 
                                    required
                                >
                                    <MenuItem value='' disabled>Please select</MenuItem>
                                    {LETTER_TYPES.map(type => (
                                        <MenuItem key={type.value} value={type.value}>{type.label}</MenuItem>
                                    ))}
                                </TextField>
                            </div>

                            {letterType === 'offerLetter' && (
                                <>
                                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-x-6 gap-y-4 pt-4 border-t border-slate-100">
                                    {renderNameAutocomplete('Employee Name', 'Name', offer.Name, handleChangeOffer, submitAttempted && !offer.Name, candidates?.map(c => c.NAME).filter(Boolean) || [])}
                                    <div>
                                        <label className={labelClass}>Offer Valid Till<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !offer.valid} placeholder="Select Offer Valid Till" value={offer.valid} onChange={handleChangeOffer} name='valid' type='date' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div>
                                        <label className={labelClass}>Date Of Joining<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !offer.doj} placeholder="Select Date Of Joining" value={offer.doj} onChange={handleChangeOffer} name='doj' type='date' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div>
                                        <label className={labelClass}>Designation<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !offer.designation} select sx={muiFieldSx} SelectProps={{ displayEmpty: true, MenuProps: { PaperProps: { style: { maxHeight: 250 } }, sx: { '& .MuiMenuItem-root': { fontSize: '14px' } } } }} fullWidth value={offer.designation || ""} onChange={handleChangeOffer} name='designation'>
                                            <MenuItem value="" disabled>Please select</MenuItem>
                                            {DESIGNATIONS.map(desig => (
                                                <MenuItem key={desig} value={desig}>{desig}</MenuItem>
                                            ))}
                                        </TextField>
                                    </div>
                                    <div>
                                        <label className={labelClass}>Offered CTC<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !offer.ctc} placeholder="Enter Offered CTC" type='text' onChange={handleChangeOffer} value={offer.ctc} name='ctc' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div>
                                        <label className={labelClass}>Address Line 1<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !offer.address1} placeholder="Enter Address Line 1" value={offer.address1} name='address1' onChange={handleChangeOffer} type='text' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    {/* <div>
                                        <label className={labelClass}>Address Line 2<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !offer.address2} placeholder="Enter Address Line 2" value={offer.address2} name='address2' onChange={handleChangeOffer} type='text' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div>
                                        <label className={labelClass}>Address Line 3<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !offer.address3} placeholder="Enter Address Line 3" value={offer.address3} name='address3' onChange={handleChangeOffer} type='text' sx={muiFieldSx} fullWidth  />
                                    </div> */}
                                    <div>
                                        <label className={labelClass}>Mail ID<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !offer.mail} placeholder="Enter Mail ID" value={offer.mail} name='mail' onChange={handleChangeOffer} type='email' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div>
                                        <label className={labelClass}>Phone Number<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !offer.number} placeholder="Enter Phone Number" value={offer.number} name='number' onChange={handleChangeOffer} type='number' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div>
                                        <label className={labelClass}>Basic<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !offer.basic} placeholder="Enter Basic" value={offer.basic} name='basic' onChange={handleChangeOffer} type='number' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div>
                                        <label className={labelClass}>HRA<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !offer.hra} placeholder="Enter HRA" value={offer.hra} name='hra' onChange={handleChangeOffer} type='number' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div> 
                                        <label className={labelClass}>Conveyance<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !offer.conveyance} placeholder="Enter Conveyance" value={offer.conveyance} name='conveyance' onChange={handleChangeOffer} type='number' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div>
                                        <label className={labelClass}>Medical<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !offer.medical} placeholder="Enter Medical" value={offer.medical} name='medical' onChange={handleChangeOffer} type='number' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div>
                                        <label className={labelClass}>Special Allowance<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !offer.sp} placeholder="Enter Special Allowance" value={offer.sp} name='sp' onChange={handleChangeOffer} type='number' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div>
                                        <label className={labelClass}>PF<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !offer.pf} placeholder="Enter PF" value={offer.pf} name='pf' onChange={handleChangeOffer} type='number' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div>
                                        <label className={labelClass}>Graduity<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !offer.graduity} placeholder="Enter Graduity" value={offer.graduity} name='graduity' onChange={handleChangeOffer} type='number' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div>
                                        <label className={labelClass}>Performance Bonus<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !offer.bonus} placeholder="Enter Performance Bonus" type='number' value={offer.bonus} name='bonus' onChange={handleChangeOffer} sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div>
                                        <label className={labelClass}>Total<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !offer.total} placeholder="Enter Total" type='number' value={offer.total} name='total' onChange={handleChangeOffer} sx={muiFieldSx} fullWidth  />
                                    </div>
                                </div>
                                <div>
                           {/* Add Component Button */}
                           <div className="flex items-center justify-between mb-3">
    <div>
        <label className={`block text-[14px] font-semibold text-slate-700 mb-0.5 text-slate-700`}>
            Custom Components
        </label>

        <p className="text-[12px] text-slate-400">
            Add additional monthly components to this offer
        </p>
    </div>
<div className="flex justify-end mb-3">
    <button
        type="button"
        onClick={addCustomComponent}
        className="inline-flex items-center gap-1.5 px-3 py-1.5
                   text-[14px] font-medium text-brand-600
                   bg-brand-50 hover:bg-brand-100
                   border border-brand-100 rounded-md
                   transition-all"
    >
        <span className="text-sm leading-none">+</span>
        Add Component
    </button>
</div>
</div>

{/* Components */}
{offer.customComponents && offer.customComponents.length > 0 && (
    <div className="border border-slate-200 rounded-lg overflow-hidden bg-white">

        {/* Column Header */}
        <div className="grid grid-cols-[1.5fr_1fr_40px] items-center
                        gap-3 px-4 py-2.5
                        bg-slate-50/70 border-b border-slate-200">

            <span className="text-xs font-semibold text-slate-700">
                Component Name
            </span>

            <span className="text-xs font-semibold text-slate-700">
                Monthly Value
            </span>

            {/* Empty column for remove action */}
            <span />
        </div>

        {/* Component Rows */}
        <div className="divide-y divide-slate-100">
            {offer.customComponents.map((comp, index) => (
                <div
                    key={index}
                    className="grid grid-cols-[1.5fr_1fr_40px] items-center
                               gap-3 px-4 py-3
                               hover:bg-slate-50/50
                               transition-colors"
                >
                    {/* Component Name */}
                    <TextField
                        placeholder="Component Name"
                        value={comp.name}
                        onChange={(e) =>
                            handleCustomComponentChange(
                                index,
                                'name',
                                e.target.value
                            )
                        }
                        type="text"
                        sx={muiFieldSx}
                        fullWidth
                    />

                    {/* Monthly Value */}
                    <TextField
                        placeholder="Monthly Value"
                        value={comp.value}
                        onChange={(e) =>
                            handleCustomComponentChange(
                                index,
                                'value',
                                e.target.value
                            )
                        }
                        type="number"
                        sx={muiFieldSx}
                        fullWidth
                    />

                    {/* Remove */}
                    <button
                        type="button"
                        onClick={() => removeCustomComponent(index)}
                        className="w-8 h-8 flex items-center justify-center
                                   text-slate-400
                                   hover:text-red-500
                                   hover:bg-red-50
                                   rounded-md
                                   transition-colors"
                        title="Remove Component"
                    >
                        <span className="text-lg leading-none">×</span>
                    </button>
                </div>
            ))}
        </div>
    </div>
)}

{/* Empty State */}
{(!offer.customComponents ||
    offer.customComponents.length === 0) && (
    <div className="mt-0 py-6 text-center
                    border border-dashed border-slate-200
                    rounded-lg bg-slate-50/30">

        <p className="text-xs font-medium text-slate-500">
            No custom components added
        </p>

        <p className="text-[11px] text-slate-400 mt-1">
            Click "Add Component" to add a monthly component
        </p>
    </div>
)}     </div>                          </>
                            )}

                            {letterType === 'internLetter' && (
                                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-4 pt-4 border-t border-slate-100">
                                    {renderNameAutocomplete('Intern Name', 'Name', Intern.Name, handleChangeIntern, submitAttempted && !Intern.Name, candidates?.map(c => c.NAME).filter(Boolean) || [])}
                                    <div>
                                        <label className={labelClass}>Roll No<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !Intern.rollNo} placeholder="Enter Roll No" type='number' value={Intern.rollNo} onChange={handleChangeIntern} name='rollNo' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div>
                                        <label className={labelClass}>Degree<span className="text-red-500">*</span></label>
                                        <TextField select sx={muiFieldSx} SelectProps={{ displayEmpty: true, MenuProps: { sx: { '& .MuiMenuItem-root': { fontSize: '14px' } } } }} fullWidth value={Intern?.degree || ""} onChange={handleChangeIntern} name='degree'>
                                            <MenuItem value="" disabled>Please select</MenuItem>
                                            {DEGREES.map(deg => (
                                                <MenuItem key={deg.value} value={deg.value}>{deg.label}</MenuItem>
                                            ))}
                                        </TextField>
                                    </div>
                                    <div>
                                        <label className={labelClass}>Department<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !Intern.depart} placeholder={"Enter Department"} value={Intern.depart} onChange={handleChangeIntern} name='depart' type='text' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div>
                                        <label className={labelClass}>College Name<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !Intern.collegename} placeholder="Enter College Name" value={Intern.collegename} onChange={handleChangeIntern} name='collegename' type='text' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div>
                                        <label className={labelClass}>Start Date<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !Intern.startdate} placeholder="Select Start Date" value={Intern.startdate} onChange={handleChangeIntern} name='startdate' type='date' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div>
                                        <label className={labelClass}>End Date<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !Intern.enddate} placeholder="Select End Date" type='date' value={Intern.enddate} onChange={handleChangeIntern} name='enddate' sx={muiFieldSx} fullWidth  />
                                    </div>
                                </div>
                            )}

                            {letterType === 'exitLetter' && (
                                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-4 pt-4 border-t border-slate-100">
                                    {renderNameAutocomplete('Employee Name', 'Name', exit.Name, handleChangeExit, submitAttempted && !exit.Name, employees?.map(emp => emp.EMP_NAME).filter(Boolean) || [])}
                                    <div>
                                        <label className={labelClass}>Employee ID<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !exit.id} placeholder="Enter Employee ID" type='text' value={exit.id} onChange={handleChangeExit} name='id' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div>
                                        <label className={labelClass}>Designation<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !exit.designation} select sx={muiFieldSx} SelectProps={{ displayEmpty: true, MenuProps: { PaperProps: { style: { maxHeight: 250 } }, sx: { '& .MuiMenuItem-root': { fontSize: '14px' } } } }} fullWidth value={exit.designation || ""} onChange={handleChangeExit} name='designation'>
                                            <MenuItem value="" disabled>Please select</MenuItem>
                                            {DESIGNATIONS.map(desig => (
                                                <MenuItem key={desig} value={desig}>{desig}</MenuItem>
                                            ))}
                                        </TextField>
                                    </div>
                                    <div>
                                        <label className={labelClass}>Date of Joining<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && (!exit.doj || (exit.exit && new Date(exit.doj) >= new Date(exit.exit)) || (exit.last && new Date(exit.doj) >= new Date(exit.last)))} placeholder="Select Date of Joining" value={exit.doj} onChange={handleChangeExit} name='doj' type='date' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div>
                                        <label className={labelClass}>Resignation Date<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && (!exit.exit || (exit.doj && new Date(exit.doj) >= new Date(exit.exit)))} placeholder="Select Resignation Date" value={exit.exit} onChange={handleChangeExit} name='exit' type='date' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div>
                                        <label className={labelClass}>Last Working Date<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && (!exit.last || (exit.doj && new Date(exit.doj) >= new Date(exit.last)))} placeholder="Select Last Working Date" value={exit.last} onChange={handleChangeExit} name='last' type='date' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    {submitAttempted && exit.doj && exit.exit && exit.last && (new Date(exit.doj) >= new Date(exit.exit) || new Date(exit.doj) >= new Date(exit.last)) && (
                                        <div className="col-span-full flex items-center gap-1.5 text-red-500 text-xs mt-[-5px] mb-2 font-medium">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                                            Date of Joining must be earlier than the Resignation and Last Working dates.
                                        </div>
                                    )}
                                </div>
                            )}

                            {letterType === 'addressProofLetter' && (
                                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-4 pt-4 border-t border-slate-100">
                                    {renderNameAutocomplete('Employee Name', 'Name', address.Name, handleChangeAddress, submitAttempted && !address.Name, employees?.map(emp => emp.EMP_NAME).filter(Boolean) || [])}
                                    <div>
                                        <label className={labelClass}>Employee ID<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !address.id} placeholder="Enter Employee ID" value={address.id} onChange={handleChangeAddress} name='id' type='text' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div>
                                        <label className={labelClass}>Designation<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !address.designation} select sx={muiFieldSx} SelectProps={{ displayEmpty: true, MenuProps: { PaperProps: { style: { maxHeight: 250 } }, sx: { '& .MuiMenuItem-root': { fontSize: '14px' } } } }} fullWidth value={address.designation || ""} onChange={handleChangeAddress} name='designation'>
                                            <MenuItem value="" disabled>Please select</MenuItem>
                                            {DESIGNATIONS.map(desig => (
                                                <MenuItem key={desig} value={desig}>{desig}</MenuItem>
                                            ))}
                                        </TextField>
                                    </div>
                                    <div> 
                                        <label className={labelClass}>Date of Joining<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !address.doj} placeholder="Select Date of Joining" type='date' value={address.doj} onChange={handleChangeAddress} name='doj' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div>
                                        <label className={labelClass}>Address Line 1<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !address.address1} placeholder="Enter Address Line 1" type='text' value={address.address1} onChange={handleChangeAddress} name='address1' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    {/* <div>
                                        <label className={labelClass}>Address Line 2<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !address.address2} placeholder="Enter Address Line 2" type='text' value={address.address2} onChange={handleChangeAddress} name='address2' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div>
                                        <label className={labelClass}>Address Line 3<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !address.address3} placeholder="Enter Address Line 3" type='text' value={address.address3} onChange={handleChangeAddress} name='address3' sx={muiFieldSx} fullWidth  />
                                    </div> */}
                                </div>
                            )}

                            {letterType === 'internOfferLetter' && (
                                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-4 pt-4 border-t border-slate-100">
                                    {renderNameAutocomplete('Intern Name', 'Name', InternOff.Name, handleChangeInternOff, submitAttempted && !InternOff.Name, candidates?.map(c => c.NAME).filter(Boolean) || [])}
                                    <div>
                                        <label className={labelClass}>Internship Start Date<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !InternOff.startdate} placeholder="Select Internship Start Date" type='date' value={InternOff.startdate} onChange={handleChangeInternOff} name='startdate' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div>
                                        <label className={labelClass}>Internship End Date<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !InternOff.enddate} placeholder="Select Internship End Date" type='date' value={InternOff.enddate} onChange={handleChangeInternOff} name='enddate' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div>
                                        <label className={labelClass}>College Name<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !InternOff.collegename} placeholder="Enter College Name" type='text' value={InternOff.collegename} onChange={handleChangeInternOff} name='collegename' sx={muiFieldSx} fullWidth  />
                                    </div>
                                </div>
                            )}

                            {letterType === 'provisionalOfferLetter' && (
                                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-4 pt-4 border-t border-slate-100">
                                    <div>
                                        <label className={labelClass}>Gender<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !provisional.Gender} select sx={muiFieldSx} SelectProps={{ displayEmpty: true, MenuProps: { sx: { '& .MuiMenuItem-root': { fontSize: '14px' } } } }} fullWidth value={provisional.Gender.toLowerCase()} onChange={handleChangeProvisional} name='Gender'>
                                            <MenuItem value="" disabled>Please select</MenuItem>
                                            <MenuItem value="male">Male</MenuItem>
                                            <MenuItem value="female">Female</MenuItem>
                                        </TextField>
                                    </div>
                                    {renderNameAutocomplete('Name', 'Name', provisional.Name, handleChangeProvisional, submitAttempted && !provisional.Name, candidates?.map(c => c.NAME).filter(Boolean) || [])}
                                    <div>
                                        <label className={labelClass}>Email<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !provisional.mail} placeholder="Enter Email" value={provisional.mail} onChange={handleChangeProvisional} name='mail' type='email' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div>
                                        <label className={labelClass}>Roll No<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !provisional.roll} placeholder="Enter Roll No" type='number' value={provisional.roll} onChange={handleChangeProvisional} name='roll' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div>
                                        <label className={labelClass}>Degree<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !provisional.degree} select sx={muiFieldSx} SelectProps={{ displayEmpty: true, MenuProps: { sx: { '& .MuiMenuItem-root': { fontSize: '14px' } } } }} fullWidth value={provisional.degree} onChange={handleChangeProvisional} name='degree'>
                                            <MenuItem value="" disabled>Please select</MenuItem>
                                            {DEGREES.map(deg => (
                                                <MenuItem key={deg.value} value={deg.value}>{deg.label}</MenuItem>
                                            ))}
                                        </TextField>
                                    </div>
                                    <div>
                                        <label className={labelClass}>Department<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !provisional.depart} placeholder={"Enter Department"} value={provisional.depart || ""} onChange={handleChangeProvisional} name='depart' type='text' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div>
                                        <label className={labelClass}>College Name<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !provisional.collegeName} placeholder="Enter College Name" value={provisional.collegeName} onChange={handleChangeProvisional} name='collegeName' type='text' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div>
                                        <label className={labelClass}>Stipend per month<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !provisional.CTC} placeholder="Enter Stipend per month" value={provisional.CTC} onChange={handleChangeProvisional} name='CTC' type='number' sx={muiFieldSx} fullWidth  />
                                    </div>
                                    <div>
                                        <label className={labelClass}>Start Date<span className="text-red-500">*</span></label>
                                        <TextField error={submitAttempted && !provisional.doj} placeholder="Select Start Date" value={provisional.doj} onChange={handleChangeProvisional} name='doj' type='date' sx={muiFieldSx} fullWidth  />
                                    </div>
                                </div>
                            )}


                        </div>
                    </form>
                </div>
            </div>
            
            <TailwindModal isOpen={previewModal} toggle={() => setPreviewModal(false)} maxWidth="4xl">
                <div className="flex flex-col bg-white overflow-hidden max-h-[90vh]" style={{ borderRadius: '24px' }}>
                    <div className="px-6 py-4 border-b border-slate-100 flex items-center justify-between bg-slate-50/50 shrink-0">
                        <h2 className="text-lg font-bold text-slate-800 flex items-center gap-2 m-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/></svg>
                            Letter Preview
                        </h2>
                        <button onClick={() => setPreviewModal(false)} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-slate-200 text-slate-500 transition-colors">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
                        </button>
                    </div>
                    <div className="p-4 sm:p-6 bg-slate-50/50 flex-1 overflow-y-auto">
                        <div className="bg-white rounded-xl p-1.5 shadow-sm border border-slate-200 min-h-[60vh] h-full flex flex-col">
                            {isPreviewLoading ? (
                                <div className="flex flex-col items-center justify-center text-slate-500 my-auto h-[60vh]">
                                    <LoaderIcon className="h-10 w-10 text-brand-600 mb-4 animate-spin" />
                                    <p className="font-medium text-lg">Generating PDF...</p>
                                    <p className="text-sm text-slate-400 mt-1">This may take a few seconds</p>
                                </div>
                            ) : pdfPreviewUrl ? (
                                <iframe 
                                    src={pdfPreviewUrl} 
                                    style={{ width: '100%', height: '100%', minHeight: '60vh' }}
                                    className="rounded-lg bg-slate-50 block flex-1"
                                    title="PDF Preview" 
                                />
                            ) : (
                                <div className="flex items-center justify-center text-slate-500 font-medium my-auto h-[60vh]">Failed to generate PDF preview.</div>
                            )}
                        </div>
                    </div>
                    <div className="px-6 py-3 border-t border-slate-100 flex justify-end gap-2 bg-white shrink-0">
                        <button onClick={() => setPreviewModal(false)} className="px-6 py-2 bg-slate-100 text-slate-600 rounded-xl hover:bg-slate-200 transition-all text-[13px] font-semibold">
                            Close
                        </button>
                        <button
                            onClick={() => {
                                setPreviewModal(false);
                                if (pdfPreviewUrl) {
                                    let name = "Letter";
                                    if (letterType === 'offerLetter') { name = "Offer-Letter"; }
                                    else if (letterType === 'internLetter') { name = "Internship-Completion-Letter"; }
                                    else if (letterType === 'internOfferLetter') { name = "Intern-Offer-Letter"; }
                                    else if (letterType === 'addressProofLetter') { name = "Address-Proof-Letter"; }
                                    else if (letterType === 'exitLetter') { name = "Exit-Letter"; }
                                    else if (letterType === 'provisionalOfferLetter') { name = "Provisional-Offer-Letter"; }

                                    const link = document.createElement('a');
                                    link.href = pdfPreviewUrl;
                                    link.download = `${name}.pdf`;
                                    document.body.appendChild(link);
                                    link.click();
                                    document.body.removeChild(link);
                                    cleanup();
                                    setIsDisabled(false);
                                } else {
                                    handleGenerate();
                                }
                            }}
                            className="px-6 py-2 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-all text-[13px] font-semibold shadow-[0_4px_12px_rgba(37,99,235,0.2)] hover:-translate-y-0.5"
                        >
                            Download
                        </button>
                    </div>
                </div>
            </TailwindModal>
        </div>
    )
}

export default LetterGeneration